import EDC from '../../shared/globals';
/**
 *
 */
EDC.Games.ImagesToTextSpace.Rocket = function (scene) {
  this.scene = scene;
  this.container = null;
  this.rocketsCountTotal = 8;
  this.flameOffset = [-75, -40, -60, -20, -40, -40, -25, -30];
  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Rocket.prototype.create = function (x, y) {
  this.container = this.scene.add.container(x, y);

  const flame = this.scene.add.sprite(0, 0, 'rocket-flame');
  this.container.add(flame);

  const rndIndex = Math.floor(Math.random() * this.rocketsCountTotal);
  const rocketSprite = this.scene.add.sprite(0, 0, `rocket${rndIndex}`);
  this.container.add(rocketSprite);

  flame.y += flame.height / 2 + this.flameOffset[rndIndex] + rocketSprite.height / 2;
  flame.setAlpha(0);
  return this;
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Rocket.prototype.start = function () {
  this.scene.tweens.add({
    targets: this.container,
    x: this.container.x + 5,
    duration: 80,
    ease: 'Linear',
    repeat: 12,
    delay: 50 + Math.floor(Math.random() * 300),
    onComplete: this.fly.bind(this),
  });
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Rocket.prototype.fly = function () {
  this.container.getAt(0).setAlpha(1);
  this.container.getAt(0).play('rocketFlame');
  this.scene.tweens.add({
    targets: this.container,
    y: -400,
    duration: 1100,
    ease: 'Linear',
    onComplete: this.away.bind(this),
  });
};
/**
 *
 */
EDC.Games.ImagesToTextSpace.Rocket.prototype.away = function () {
  this.scene.events.emit(this.scene.signals.S_ROCKET_AWAY);
};

export default EDC.Games.ImagesToTextSpace.Rocket;
